import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import useMediaQuery from '@mui/material/useMediaQuery'
import { HereMapClickEvent } from '@user/components/HereMap/HereMapNew/hooks/useHereMapInstance'
import { AddLeadPage } from '@user/components/Leads/AddLeadPage'
import { EntityLocationDTO } from '@user/store/map/typings'

type Props = {
  open: boolean
  address: HereMapClickEvent | null
  onClose: () => void
  handleDuplicateManageClick: () => void
  handleMapAfterAddLeadSaveSuccess: (newPin: EntityLocationDTO) => void
  draftId?: string | null
}

export function AddLeadModal({
  open,
  address,
  onClose,
  handleMapAfterAddLeadSaveSuccess,
  handleDuplicateManageClick,
  draftId,
}: Props) {
  const isMobile = useMediaQuery('(max-width:900px)')
  const handleDialogClose: NonNullable<
    React.ComponentProps<typeof Dialog>['onClose']
  > = (_event, reason) => {
    if (reason === 'backdropClick') return

    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: isMobile ? '100svw' : '660px',
          height: '90vh',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      }}
    >
      <AddLeadPage
        fromMapView
        onClose={onClose}
        selectedMapLocation={address}
        handleMapAfterAddLeadSaveSuccess={handleMapAfterAddLeadSaveSuccess}
        handleDuplicateManageClick={handleDuplicateManageClick}
        draftId={draftId}
      />
    </Dialog>
  )
}
